exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".benefits-tier-chip[data-v-48a9e1ce] {\n  align-items: center;\n  display: inline-flex;\n  gap: 4px;\n}\n.benefits-tier-chip-icon[data-v-48a9e1ce] {\n  height: 16px;\n  line-height: 16px;\n  -o-object-fit: contain;\n     object-fit: contain;\n  width: 16px;\n}", ""]);

// exports
